import { centsToDollars, parsePrice } from "helpers/price";
import { HorizontalLine } from "pages/Dashboard/components/styled";
import { useMemo, useState } from "react";

export function AvgPriceSpread({ top10Data }: { top10Data: any }) {
  const [expandedKeys, setExpandedKeys] = useState<Record<string, boolean>>({});
  const summary = useMemo(() => {
    return [
      {
        label: "Highest Avg Commercial Rate",
        value: top10Data?.payerCentricApproachSummary.maxCommercialAverage
          ? parsePrice(
              centsToDollars(
                top10Data.payerCentricApproachSummary.maxCommercialAverage
              )
            )
          : "N/A",
        payers:
          top10Data?.payerCentricApproachSummary.highestCommercialPayers.map(
            (p: any) => p.payerName
          ),
        key: "highestCommercialPayers",
      },
      {
        label: "Lowest Avg Commercial Rate",
        value: top10Data?.payerCentricApproachSummary.minCommercialAverage
          ? parsePrice(
              centsToDollars(
                top10Data.payerCentricApproachSummary.minCommercialAverage
              )
            )
          : "N/A",
        payers:
          top10Data?.payerCentricApproachSummary.lowestCommercialPayers.map(
            (p: any) => p.payerName
          ),
        key: "lowestCommercialPayers",
      },
      {
        label: "Medicare Avg Rate",
        value: top10Data?.payerCentricApproachSummary.medicareAverage
          ? parsePrice(
              centsToDollars(
                top10Data.payerCentricApproachSummary.medicareAverage
              )
            )
          : "N/A",
      },
      {
        label: "Avg Commercial Rate",
        value: top10Data?.payerCentricApproachSummary
          .averagePriceOfferedAccrossPayers
          ? parsePrice(
              centsToDollars(
                top10Data.payerCentricApproachSummary
                  .averagePriceOfferedAccrossPayers
              )
            )
          : "N/A",
      },
    ];
  }, [top10Data]);

  const toggleExpand = (key: string) => {
    setExpandedKeys((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };
  return (
    <div className="flex flex-column gap-2">
      {summary.map((item, index) => {
        const isExpanded = item.key && expandedKeys[item.key];
        const payers = item.payers || [];
        const visiblePayers = isExpanded ? payers : payers.slice(0, 2);
        const remainingCount = payers.length - 2;
        return (
          <div className="flex flex-column" key={`summary_${index}`}>
            <div className="flex w-full justify-content-between align-items-center">
              <p className="text-sm text-gray-new-900">{item.label}</p>
              <div className="flex flex-column gap-1 text-right">
                <p className="text-primary font-semibold text-md">
                  {item.value}
                </p>
                {payers?.length ? (
                  <div className="flex flex-column gap-1">
                    {visiblePayers.map((payer: string, idx: number) => (
                      <p key={idx} className="text-gray-500 text-xs">
                        {payer}
                      </p>
                    ))}
                  </div>
                ) : null}
                {!isExpanded && remainingCount > 0 && item.key && (
                  <button
                    type="button"
                    onClick={() => toggleExpand(item.key)}
                    className="text-gray-500 text-xs underline p-0 bg-transparent border-none cursor-pointer"
                  >
                    Show more
                  </button>
                )}
                {isExpanded && payers.length > 2 && item.key && (
                  <button
                    type="button"
                    onClick={() => toggleExpand(item.key)}
                    className="text-gray-500 text-xs underline p-0 bg-transparent border-none cursor-pointer"
                  >
                    Show Less
                  </button>
                )}
              </div>
            </div>
            <HorizontalLine className="border-gray-new-200 w-full my-3" />
          </div>
        );
      })}
    </div>
  );
}
